import { defineMessages } from 'react-intl'

export default defineMessages({
  notificationActivityByDeviceSectionTitle: {
    id: 'AnalyticsPage.WorkshopNotifications.MemberActivityByDevice.Title',
    defaultMessage: 'Notification Activity By Channel'
  },
  userActivityDeviceChartLabelDesktop: {
    id: 'AnalyticsPage.WorkshopNotifications.userActivityDeviceChartLabelDesktop.Label',
    defaultMessage: 'Desktop'
  },
  userActivityDeviceChartLabelMobile: {
    id: 'AnalyticsPage.WorkshopNotifications.userActivityDeviceChartLabelMobile.Label',
    defaultMessage: 'Mobile'
  },
  userActivityDeviceChartLabelToolbar: {
    id: 'AnalyticsPage.WorkshopNotifications.userActivityDeviceChartLabelToolbar.Label',
    defaultMessage: 'Toolbar'
  },
  userActivityDeviceChartLabelTeams: {
    id: 'AnalyticsPage.WorkshopNotifications.userActivityDeviceChartLabelTeams.Label',
    defaultMessage: 'Teams'
  },
  noActivityMetrics: {
    id: 'AnalyticsPage.WorkshopNotifications.noActivityMetrics.Message',
    defaultMessage: 'No Activity Data for the Date Range'
  }
})
